export default "/images/ico-h-message.svg?b52eea3172f6004d696809615e5631f9";